import React, {useEffect, useState} from 'react';
import {callEmptyParamsApi} from "../../../connection/ClientApi";
import IconTitleValue from "components/textValue/IconTitleValue";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import Space from "../../../components/space/Space";
import {ALERT_TYPES} from "components/alertMassage/AlertMessage";
import {IsLP_MP_SP, IsLP_MP_SP_T} from "my-styles/media/media";
import Progress from '@delowar/react-circle-progressbar';
import Urls from "../../../connection/Urls";
import messages from "res/messages/farsi";
import {Divider} from "@material-ui/core";
import copy from "copy-to-clipboard";

import ICHttpIcon from '@mui/icons-material/Phonelink';
import ICCopy from '@mui/icons-material/FileCopy';
import ICInviteFriendDesktop from "res/images/invite_friend_desktop.png";
import ICInviteFriendMobile from "res/images/invite_friend_mobile.png";

export default function InviteFriend(props) {

    const [isCancelled, setIsCancelled] = useState(false)
    const [inviteFriend, setInviteFriend] = useState()

    function requestGetInviteFriend() {
        callEmptyParamsApi(Urls.getInviteFriend, (data) => {
            if (isCancelled) return

            if (data.invite_description.length <= 0) {
                data.invite_description = messages.inviteDescription
            }
            setInviteFriend(data)
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    useEffect(() => {
        requestGetInviteFriend()

        return () => {
            setIsCancelled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (<>
        {inviteFriend &&
        <div className="hInLP_vInTFMS wInLP100_wInTFMS95">
            <div className="hideInLPT_showInFMS fullWidth">
                <img className="fullWidth" src={ICInviteFriendMobile} alt={"صرفه مارکت"}/>
            </div>
            <div className="marginTopBottomMedium marginRightMedium wInLP65_wInTFMS100">
                <div className="center fullWidth">
                    <div className="center horizontalScreen">
                        <div className="center marginSmall">
                            <Progress
                                isGradient
                                borderWidth="15"
                                size={120}
                                percent={100}
                                gradient={{
                                    angle: 90,
                                    startColor: '#ED2A00',
                                    stopColor: '#10AD23'
                                }}>
                                {inviteFriend.invited}
                            </Progress>
                            <Space/>
                            <label className="largeTextBold center fullWidth">
                                {messages.invited}
                            </label>
                        </div>
                        <div className="center marginSmall">
                            <Progress
                                isGradient
                                borderWidth="15"
                                size={120}
                                percent={100}
                                gradient={{
                                    angle: 90,
                                    startColor: '#3FD3BB',
                                    stopColor: '#2969B0'
                                }}>
                                {inviteFriend.registerd}
                            </Progress>
                            <Space/>
                            <label className="largeTextBold center fullWidth">
                                {messages.registered}
                            </label>
                        </div>
                    </div>
                    <Divider/>
                </div>
                <Space height={"2em"}/>
                <div>
                    <label className="largeText">
                        {inviteFriend.invite_description}
                    </label>
                    <Space/>
                    <div className="hInLP_vInTFMS">
                        <div className="hInLPT_vInFMS">
                            <IconTitleValue
                                icon={<ICHttpIcon className="xSmallIcon marginTopSmall"/>}
                                titleClassName={"largeText"}
                                title={inviteFriend.invite_message}/>
                            <div
                                className={IsLP_MP_SP_T() ? "marginTopSmall" : "fullWidth left"}>
                                <a className="largeTextBold blueColor textUnderined"
                                   href={"//" + inviteFriend.invite_url}
                                   target="_blank"
                                   rel="noopener noreferrer">
                                    {inviteFriend.invite_url}
                                </a>
                            </div>
                        </div>
                        <div className={IsLP_MP_SP() ? "marginRightMedium" : "toLeft marginTopMedium"}>
                            <IconTitleButtonRound
                                height={"3em"}
                                width={"10em"}
                                direction="ltr"
                                fontSize="mediumTextBold"
                                onClick={() => {
                                    copy(inviteFriend.invite_url)
                                    props.onAlert(messages.inviteLinkCopied, ALERT_TYPES.SUCCESS)
                                }}
                                icon={<ICCopy className={'whiteColor'}/>}
                                title={messages.copy}/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="marginTopBottomMedium showInLP_hideInTFMS wInLP35_wInTFMS100" style={{float: "left"}}>
                <img className="fullWidth" src={ICInviteFriendDesktop} alt={"صرفه مارکت"}/>
            </div>
        </div>
        }
    </>)

}